module.exports = __webpack_public_path__ + "img/tempuracaliforniavonoben.d584f819.jpg";